import school1 from "../../assets/school1.jpg";

const History = () => {
    return (
        <div id="history" className="vision-card history-card">

            <div className="history-content">

                {/* =========================================
                    SCHOOL IMAGE
                ========================================= */}

                <div className="about-img history-image">

                    <div className="history-image-wrap">

                        <img
                            src={school1}
                            alt="Nav Jeevan Mission School"
                        />

                    </div>

                </div>


                {/* =========================================
                    HISTORY CONTENT
                ========================================= */}

                <div className="about-text history-text">

                    {/* MAIN HEADING */}

                    <div className="history-heading">

                        <span className="history-label">
                            ABOUT OUR SCHOOL
                        </span>

                        <h2>
                            SCHOOL HISTORY
                        </h2>

                        <div className="history-line"></div>

                    </div>


                    {/* INTRODUCTION */}

                    <p>
                        Nav Jeevan Mission School, Anandnagar, carries forward a rich legacy of commitment to quality education, character formation and holistic development. The journey of the Nav Jeevan Mission educational movement began in 1990 in Kasia, Kushinagar, with the vision of providing quality English-medium education to children in the region.
                    </p>

                    <p>
                        Inspired by the vision of its founders, the institution has continued to grow with a strong commitment to nurturing young minds academically, morally, socially and spiritually. The guiding philosophy has always been to prepare students to become responsible, confident and compassionate citizens who can contribute positively to society.
                    </p>


                    {/* =========================================
                        THE ANANDNAGAR CHAPTER
                    ========================================= */}

                    <div className="history-subsection">

                        <div className="history-subheading">

                            <span className="history-dot"></span>

                            <h3>
                                The Anandnagar Chapter
                            </h3>

                        </div>

                        <p>
                            Building upon this established educational legacy, Nav Jeevan Mission School, Anandnagar, was established in 2005 on Sonauli Road, Anandnagar, Maharajganj. The school officially opened on 4 April 2005 and has grown steadily into a Senior Secondary CBSE-affiliated institution.
                        </p>

                        <p>
                            Over the years, the Anandnagar campus has developed into a vibrant centre of learning, providing education from the foundational level through Class XII. The school combines academic learning with sports, arts, technology, cultural activities, leadership opportunities and character development.
                        </p>

                        <p>
                            The school is managed by the A.C. George Memorial Education Society and is committed to providing an environment where every child is encouraged to discover his or her potential, develop confidence and strive for excellence.
                        </p>

                    </div>


                    {/* =========================================
                        GROWING WITH THE TIMES
                    ========================================= */}

                    <div className="history-subsection">

                        <div className="history-subheading">

                            <span className="history-dot"></span>

                            <h3>
                                Growing with the Times
                            </h3>

                        </div>

                        <p>
                            From its humble beginnings, Nav Jeevan Mission School, Anandnagar, has continuously developed its academic programmes, infrastructure and learning opportunities. The school now provides modern learning facilities, technology-supported education and opportunities for students to participate in a wide range of curricular and co-curricular activities.
                        </p>

                        <p>
                            The institution remains committed to its enduring philosophy of education with values, preparing students not only for examinations and careers but also for responsible citizenship and meaningful service to society.
                        </p>

                    </div>


                    {/* =========================================
                        OUR MOTTO
                    ========================================= */}

                    <div className="history-motto">

                        <span className="motto-label">
                            OUR MOTTO
                        </span>

                        <h3>
                            “ARISE AND SHINE”
                        </h3>

                        <p>
                            This motto reflects the school’s aspiration to inspire every student to rise above challenges, discover their God-given abilities, pursue excellence and shine as responsible citizens and future leaders.
                            Today, Nav Jeevan Mission School, Anandnagar, stands as a growing educational institution with a strong foundation, a proud legacy and a vision for a bright future.
                            Short version for the website
                        </p>

                    </div>


                    {/* =========================================
                        SHORT VERSION
                    ========================================= */}

                    <div className="history-short-version">

                        <span className="history-short-label">
                            SHORT VERSION FOR THE WEBSITE
                        </span>

                        <p>
                            Nav Jeevan Mission School, Anandnagar, established in 2005, is part of a rich educational legacy that began in Kasia in 1990. Founded with a vision to provide quality education and holistic development, the institution has grown into a Senior Secondary CBSE-affiliated school on Sonauli Road, Anandnagar. The school is committed to academic excellence, character formation, leadership, technology, sports and co-curricular development. With the motto “ARISE AND SHINE,” we strive to empower every student to discover their potential, serve society and become responsible citizens and future leaders.
                        </p>

                    </div>

                </div>

            </div>

        </div>
    );
};

export default History;